import * as R from "ramda";
import axios from 'axios'

const SERVER_URL = `${process.env.VUE_APP_SERVER_URL}`;

const intentStore = {
    namespaced: true,

    state: {
        intent_field: ['d1', 'd2', 'd3', 'useyn', "관리"],
        intent_type: 1,
        gbn1: null,
        gbn2: null,
        gbn3: null,
        intents: [],

    },
    getters: {

    },
    mutations: {
        updateIntentType(state, val) {
            state.intent_type = val;
        },
        updateGbn1(state, val) {
            state.gbn1 = val;
        },
        updateGbn2(state, val) {
            state.gbn2 = val;
        },
        updateGbn3(state, val) {
            state.gbn3 = val;
        },
    },
    actions: {
        async saveIntent(context, payload) {
            let url = `${SERVER_URL}/intent`;
            let resp = await axios.post(url, payload);

        },
        async saveSenIntent(context, payload) {
            let url = `${SERVER_URL}/senintent`;
            let resp = await axios.post(url, payload);
        },

        async putIntent(context, payload) {

            let url = `${SERVER_URL}/intent/${payload.id}`;
            let resp = await axios.put(url, payload);
        },

        async putSenIntent(context, payload) {
            let url = `${SERVER_URL}/senintent/${payload.id}`;
            let resp = await axios.put(url, payload);
        },



        async LoadIntent(context, srhtext) {
            let url = `${SERVER_URL}/intent?q=${srhtext}`;
            let resp = await axios.get(url);

            context.state.intents = resp.data;
        },
        async LoadSenIntent(context, srhtext) {
            let url = `${SERVER_URL}/senintent?q=${srhtext}`;
            let resp = await axios.get(url);

            context.state.intents = resp.data;
        },

        async LoadIntentForAdmin(context, srhtext) {
            let url = `${SERVER_URL}/intentadmin?q=${srhtext}`;
            let resp = await axios.get(url);

            context.state.intents = resp.data;
        },
        async LoadSenIntentForAdmin(context, srhtext) {
            let url = `${SERVER_URL}/senintentadmin?q=${srhtext}`;
            let resp = await axios.get(url);

            context.state.intents = resp.data;
        }


    }

}
export default intentStore;